module.exports = __webpack_public_path__ + "img/17_79.450850a9.png";